import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-custom-button',
    templateUrl: './custom-button.component.html',
    styleUrls: ['./custom-button.component.scss']
})
export class CustomButtonComponent implements OnInit {

    @Input() text: string;
    @Input() color: string;
    @Input() styleClass: string;
    @Input() icon: string;
    @Input() disabled: boolean;
    @Input() ariaLabel: string;

    constructor() {
    }

    ngOnInit() {
        this.color = this.color || 'primary';
    }
}
